export default __webpack_public_path__ + "static/media/pen.07158648.svg";